<!-- Convenios Detalle -->
<p-panel header="{{ 'CONVENIOS.LBL_CONVENIOS' | translate}}">

  <div *ngIf="model">
    <div class="grid">
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONVENIOS.LBL_NUMEROCONTRATO' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8 "><strong>{{model.numeroContrato}}</strong></label>
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_NOMBRE' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8"><strong>{{model.nombre}}</strong></label>
    </div>
    <div class="grid">
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_FECHAINICIO' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8 "><strong>{{model.fechaDesde}}</strong></label>
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_FECHAFIN' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8"><strong>{{model.fechaHasta}}</strong></label>
    </div>
    <div class="grid">
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONVENIOS.LBL_OPCIONDESEMBOLSO' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8 "><strong>{{model.nombreOpcionDesembolso}}</strong></label>
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8"><strong>{{(model.indicadorHabilitado ? 'BTN_SI' : 'BTN_NO') | translate}}</strong></label>
    </div>
    <div class="grid text-center">
      <div class="form-group col-12 text-center">
        <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button" pButton (click)="atras()"></button>
      </div>
    </div>

  </div>
</p-panel>
